// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"80e25da42a1becb9fad9","655":"3a151f1d9c5f65729f8d"}[chunkId] + ".js";
};